import React from "react";

export enum TextType {
  CAPTION = "CAPTION",
  BASE_CAPTION = "BASE_CAPTION",
  SUB_CAPTION = "SUB_CAPTION",
  PARAGRAPH = "PARAGRAPH",
  LINK = "LINK",
}

export type TypographyProps = {
  type: TextType
  position?: "center" | "left" | "right";
  gradient?: string;
  children: React.ReactNode,
  href?: string,
  marginTop?: string;
  marginBottom?: string;
  color?: "white" | "black";
  maxWidth?: string;
  className?: string;
}

export const Typography = ({ type, position, gradient, children, href, marginTop, marginBottom, color, maxWidth, className }: TypographyProps) => {
  switch (type) {
    case TextType.CAPTION: {
      return <h1
        className="w-full mb-3 text-center text-[48px] md:text-[56px] font-bold leading-[105%] md:leading-[56px] -tracking-[.96px] md:-tracking-[1.12px] text-main-primary"
        style={{ textAlign: position }}
      >
        {typeof children === "string"
          ? children
          : React.Children.map(children, (child) =>
            typeof child === "string"
              ? child
              : <span className={`${gradient} bg-clip-text text-transparent`}>{child}</span>
          )}
      </h1>
    }

    case TextType.BASE_CAPTION: {
      return <></>
    }

    case TextType.SUB_CAPTION: {
      return <h1
        className={`
        w-full md:text-center text-[32px] font-bold leading-[115%] md:leading-[36px] 
        ${position === "left" ? "text-center md:text-left" : "text-center"}
        font-visby -tracking-[.32px] ${color === "white" ? "text-white" : "text-main-primary"}
      `}
        style={{ marginTop, marginBottom, textAlign: position }}
      >
        {children}
      </h1>
    }

    case TextType.PARAGRAPH: {
      return <p
        className={`w-full font-visby text-lg font-semibold leading-[140%] -tracking-[.18] text-gray-500 ${className}`}
        style={{ textAlign: position, marginTop, marginBottom, maxWidth }}
      >
        {typeof children === "string"
          ? children
          : React.Children.map(children, (child) =>
            typeof child === "string"
              ? child
              : <span className={`font-bold tracking-normal ${gradient} bg-clip-text text-transparent`}>
                {child}
              </span>
          )}
      </p>
    }

    case TextType.LINK: {
      return <a href={href} className="text-base font-semibold leading-[140%] text-blue-400">{children}</a>
    }
  }
}
